import { action, extendObservable } from 'mobx';
import FetchService from '../../../core/services/FetchService';
import NotificationService from '../../../core/services/NotificationService';
import CertificationTestRegisterItemListService from './CertificationTestRegisterItemListService';
import FormService from '../../../core/services/FormService';
import { isRequired } from '../../../core/validations';

class CreateCertificationItemDraftDialogService {
  form = new FormService();
  fetch = new FetchService();
  submit = new FetchService();

  constructor() {
    extendObservable(this, {
      isOpen: false,
      certificationTestCourseAbilityItem: null,
    });
    this.form.validations = {
      draftCreationReason: [isRequired],
    };
  }

  handleShow = action((certificationTestCourseAbilityItem) => {
    this.isOpen = true;
    this.certificationTestCourseAbilityItem = {
      certificationTestCourseAbility: {
        id: certificationTestCourseAbilityItem.certificationTestCourseAbility.id,
        ability: certificationTestCourseAbilityItem.certificationTestCourseAbility.ability,
        course: certificationTestCourseAbilityItem.certificationTestCourseAbility.course,
      },
      item: certificationTestCourseAbilityItem.item,
    };
  });

  handleClose = action(() => {
    this.isOpen = false;
    this.form.reset();
  });

  handleSubmit = action(() => {
    this.form.setSubmitted();
    if (this.form.errors) {
      return;
    }
    this.submit
      .fetch({
        method: 'post',
        url: `/certification-test-course-ability/${this.certificationTestCourseAbilityItem.certificationTestCourseAbility.id}/items/${this.certificationTestCourseAbilityItem.item.id}/draft`,
        body: {
          ...this.form.getValues(),
        },
      })
      .then(() => {
        if (this.submit.data) {
          NotificationService.addNotification('Drat successfully created', 'success');
          CertificationTestRegisterItemListService.load();
          this.handleClose();
        }
        if (this.submit.error) {
          NotificationService.addNotification('Error to create draft', 'error');
        }
      });
  });
}

const createCertificationItemDraftDialogService = new CreateCertificationItemDraftDialogService();

export default createCertificationItemDraftDialogService;
